import { RadioButtonType } from '@labrav/react-components'
import { ResellerAgreementStatus } from '../../admin/modules/resaleAuthorizations'
import { EulaType } from '../../modules/privateOffer/types'

export const getActiveStepLable = (status: ResellerAgreementStatus) => {
  switch (status) {
    case ResellerAgreementStatus.IN_PROGRESS:
      return 'Creation In Progress'
    case ResellerAgreementStatus.ACTIVE:
      return 'Active'
    case ResellerAgreementStatus.EXPIRED:
      return 'Expired'
    case ResellerAgreementStatus.COMPLETED:
      return 'Completed'
    case ResellerAgreementStatus.CHANNEL_OFFER_ACCEPTED:
      return 'Completed'
    case ResellerAgreementStatus.DEACATIVATION_IN_PROGRESS:
      return 'Deactivation in Progress'
    case ResellerAgreementStatus.RESTRICTED:
      return 'Restricted'
    default:
      return ''
  }
}

export const getEulaOptionsForResaleAuthorization = ({
  standardUrl,
  eulaKey,
  productEulaUrl,
}: {
  standardUrl: string
  eulaKey: string
  productEulaUrl?: string
}) => {
  const agreementOption = [
    {
      key: EulaType.STANDARD,
      label: 'Standard',
      type: RadioButtonType.STANDARD,
      url: standardUrl,
    },
    {
      key: EulaType.CUSTOM,
      label: 'Custom',
      type: RadioButtonType.CUSTOM,
    },
  ]
  const agreementOptionWithPublic = [
    {
      key: EulaType.PUBLIC,
      label: 'Public',
      type: RadioButtonType.STANDARD,
      url: productEulaUrl,
    },
    ...agreementOption,
  ]
  return eulaKey !== 'resellerLicenseAgreementType'
    ? agreementOptionWithPublic
    : agreementOption
}
